import { type JSX } from 'react';
import { useFocusedElementLines } from 'ts/commons/code/CodeToken.focus';
import { useRenderedCodeOptions } from 'ts/commons/code/RenderedCode.context';

/** Renders the outline bar next to the code view, which shows e.g. highlighted identifiers across the whole file. */
export function CodeOutlineBar(): JSX.Element | null {
	const { totalLineCount, imperativeHandleRef } = useRenderedCodeOptions();
	const highlightedLinesForOutlineBar = useFocusedElementLines();

	return (
		<div className="w-[20px] bg-white max-h-full">
			<svg width="20" height="100%">
				{highlightedLinesForOutlineBar.map(lineNumber => {
					const yPercent = (100 * (lineNumber - 1)) / totalLineCount + '%';
					return (
						<rect
							key={'highlight-' + lineNumber}
							onClick={() => imperativeHandleRef.current?.scrollTo({ line: lineNumber, flash: true })}
							x="0"
							y={yPercent}
							width="100%"
							height="6"
							fill="#4b79cb"
							className="cursor-pointer"
						>
							<title>Jump to line {lineNumber}</title>
						</rect>
					);
				})}
			</svg>
		</div>
	);
}
